export enum ReductionType {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
}

export enum DEVIS_STATUS {
  DRAFT = 'draft',
  VALIDATED = 'validated',
  SENT = 'sent',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted',
}

export interface DevisLineItem {
  articleId?: string;
  description: string;
  quantity: number;
  unitPriceHT?: number;
  reductionType?: ReductionType;
  reductionAmount?: number;
  vatAmount?: number;
  totalTTC: number;
  totalHT: number;
  priceHT?: number;
  ebpId?: string;
}

export interface DevisClient {
  _id: string;
  name: string;
  code: string;
  siret: string;
  address: string;
  email: string;
}

export interface DocumentSummary {
  totalHT: number;
  totalRemise: number;
  totalHTFinal: number;
  totalVAT: number;
  totalTTC: number;
  vatPercentage: number;
}

export interface Devis {
  _id: string;
  summary?: DocumentSummary;
  totalTTC: number;
  totalHT: number;
  dueDate: Date;
  documentNumber: {
    number: string;
    prefix: string;
    suffix: string;
  };
  createdAt: Date;
  updatedAt: Date;
  status: DEVIS_STATUS;
  archived: boolean;
  lineItems: DevisLineItem[];
  clientId: string;
  client: DevisClient;
  ebpId?: string;
  workspaceId: string;
  interveners?: string[];
}

export interface DevisFilter {
  dateRange?: {
    from: Date;
    to: Date;
  };
  status?: string;
  client?: string;
}

export interface CreateDevisPayload {
  _id?: string;
  totalTTC: number;
  totalHT: number;
  lineItems: DevisLineItem[];
  clientId: string;
  ebpId?: string;
  status?: DEVIS_STATUS;
  archived?: boolean;
  interveners?: string[];
  dueDate: Date;
  articleId?: string;
  reductionType?: ReductionType;
  reductionAmount?: number;
}

export interface SendDevisPayload {
  to: string;
  subject: string;
  text?: string;
  html?: string;
  invoiceId?: string;
  quoteId?: string;
  attachment?: { filename: string; content: string; encoding?: string };
  pdfAttachment?: { filename: string; content: Buffer };
}